export const listingScoreSessionStorageKey = "listing-quality-score-hints-expanded"
